import { z } from 'zod'
import { productCategoryInputSchema } from '../../input/product-category-schema'
import { productSchema, productVariantSchema } from '../../input/product-schema'
import { filterableStateSchema } from '../base'

// -------------------------
// Product State Validation
// -------------------------
export const productStateItemSchema = productSchema.extend({
  title: z.string().optional(),
  isSelected: z.boolean().optional(),
  localDraft: z.boolean().optional(),
  variants: z.array(productVariantSchema).optional()
})

export const productStateSchema = filterableStateSchema.extend({
  items: z.array(productStateItemSchema),
  selectedProduct: productStateItemSchema.nullable(),
  selectedVariant: productVariantSchema.nullable().optional()
})

export const productActionValidation = {
  'products/setProducts': z.array(productStateItemSchema),
  'products/updateProduct': productStateItemSchema,
  'products/setSelectedProduct': productStateItemSchema,
  'products/setSelectedVariant': productVariantSchema,
  'products/addVariant': productVariantSchema,
  'products/updateVariant': productVariantSchema,
  'products/removeVariant': z.string()
} as const

// -------------------------
// Product Variant State Validation
// -------------------------
export const productVariantStateItemSchema = productVariantSchema.extend({
  isSelected: z.boolean().optional()
})

// -------------------------
// Product Category State Validation
// -------------------------
export const productCategoryStateItemSchema = productCategoryInputSchema.extend({
  productCount: z.number().optional(),
  isExpanded: z.boolean().optional(),
  hasChildren: z.boolean().optional()
})

export const productCategoryStateSchema = filterableStateSchema.extend({
  items: z.array(productCategoryStateItemSchema),
  selectedCategory: productCategoryStateItemSchema.nullable()
})

export const productCategoryActionValidation = {
  'productCategories/setCategories': z.array(productCategoryStateItemSchema),
  'productCategories/updateCategory': productCategoryStateItemSchema,
  'productCategories/setSelectedCategory': productCategoryStateItemSchema
} as const

// Type inference helpers
export type ProductStateValidation = z.infer<typeof productStateSchema>
export type ProductVariantStateValidation = z.infer<typeof productVariantStateItemSchema>
export type ProductCategoryStateValidation = z.infer<typeof productCategoryStateSchema>
